import wx from 'weixin-js-sdk'

import _ from 'underscore'

import { app } from './platform'
import wechatService from '../service/wechat'

const env = process.env
export default function ready() {
  const cf = {
    jsApiList: [
      "scanQRCode",
      "onMenuShareAppMessage",
      "onMenuShareTimeline",
      // TODO:
      "startRecord",
      "stopRecord",
      "onVoiceRecordEnd",
      "playVoice",
      "uploadVoice"
    ],
    openTagList: ["wx-open-launch-weapp"]
    // debug: env === 'development'
  }
  if (!app.isWechat()) {
    return console.log('invoke wechat jssdk fail')
  }
  return new Promise((resolve, reject) => {
    return wechatService.config().then(data => {
      const wxcf = _.assign({}, data, cf)
      wx.config(wxcf)
      return wx.ready(() => {
        return resolve(wx)
      })
    }, (e) => {
      console.log('get wechat jssdk config fail.')
      reject(e)
    })
  })
}
